<template>
  <v-app id="app" class="bg-background">
    <Navbar v-if="showAppDrawer"/>
    <v-main class="mx-6 mt-3 fade-in">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>
    <v-footer v-if="showAppDrawer" app class="white">
      <div class="d-flex justify-space-between align-center w-100">
        <div>
          <small class="grey--text text--darken-1">Version Product: 1.2.5</small>
        </div>
        <div>
          <small>
            <a href="https://mumble.group" target="_blank" class="if65Blue--text font-weight-medium">
              Mumble Group© {{ new Date().getFullYear() }} | all-right reserved to IF65 srl
            </a>
          </small>
        </div>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";
import "./style/global.css";
import "./style/tables.css";
import "./style/forms.css";
import "./style/custom.css";
import SettingsService from "./services/settings.service";

export default {
  name: 'App',
  components: {
    Navbar,
  },
  created() {
    const token = localStorage.getItem('token')
    if (token && token !== 'null') {
      this.$store.dispatch('setCurrentUser')
    }
    this.$root.$on('renderError', xhr => this.onRenderError(xhr));

    // Applica le impostazioni salvate
    SettingsService.initSettings();
  },
  computed: {
    showAppDrawer() {
      return this.$store.state.user && this.$route.name !== 'login';
    }
  },
  methods: {
    onRenderError(xhr) {
      const status = xhr.response.status
      const data = xhr.response.data
      if (status === 400) {
        if (Array.isArray(data)) {
          this.renderError(data.join(', '))
        } else {
          Object.entries(data).forEach(
              ([key, value]) => {
                if (key === 'non_field_errors') {
                  for (const nfe of value) {
                    this.renderError(nfe)
                  }
                } else {
                  this.renderError(`${key}: ${value}`)
                }
              }
          );
        }
      }
    },
    renderError(errorString) {
      this.$dtoast.pop({
        preset: "error",
        content: errorString
      })
    }
  }
};
</script>
<style>
/* Stili per le transizioni di pagina */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Stili per le transizioni di elementi */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>
